import Vue from 'vue'

import PortalVue from 'portal-vue'
import VueMq from 'vue-mq'

import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'

import App from './App.vue'
import router from './router'

Vue.use(PortalVue)
Vue.use(Croppa)

Vue.use(VueMq, {
	breakpoints: {
		s: 640,
		m: 960,
		l: 1200,
		xl: 1600,
		i: Infinity
	}
})

import VueMatomo from 'vue-matomo'
Vue.use(VueMatomo, {
	host: process.env.VUE_APP_TRACKING_HOST,
	siteId: process.env.VUE_APP_TRACKING_SITE_ID,
	trackerFileName: 'piwik',
	router: router,
	enableLinkTracking: true,
	requireConsent: false,
	trackInitialView: process.env.VUE_APP_TRACKING_SITE_ID > 0 ? true : false,
	debug: false
})

// eslint-disable-next-line
router.afterEach((to, from) => {
	if (
		process.env.VUE_APP_TRACKING_SITE_ID > 0 &&
		window.Piwik
	) {
		window.Piwik.getTracker().trackPageView(to.meta.title)
	}
})

import MetaInfo from './components/MetaInfo.vue'

Vue.component('meta-info', MetaInfo)

Vue.config.productionTip = false

new Vue({
  router,
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    }
  },
  render: h => h(App)
}).$mount('#app')
